export default __webpack_public_path__ + "static/Phone_mock_credfin-db73f236cc0f9b795d22430dd1735bb0.png";